import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  createQRCode({ commit }) {
    return new Promise((resolve, reject) => {
      API.twoFactorAuthentication.generateQRCode(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  saveQRCode({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.twoFactorAuthentication.confirmQRCode(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  removeQRCode({ commit }) {
    return new Promise((resolve, reject) => {
      API.twoFactorAuthentication.deleteTwoFactorAuthentication(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/twoFactorAuthentication.js